<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn :color="buttonColor"
               class="mr-2"
               dark
               fab
               depressed
               small
               v-on="on"
               @click="changeEditingMode(!isTableEditingMode)">
          <v-icon>{{ !isTableEditingMode ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
        </v-btn>
      </template>
      <span>
        {{ !isTableEditingMode ? $t('general.startEditingMode') : $t('general.stopEditingMode')  }}
      </span>
    </v-tooltip>
  </span>
</template>

<script>
import { mapState } from 'vuex'
export default {
  beforeDestroy () {
    this.changeEditingMode(false)
  },
  computed: {
    ...mapState({
      isTableEditingMode: state => state.dataTables.isTableEditingMode
    })
  },
  created () {
    this.changeEditingMode(false)
    document.addEventListener('keydown', e => this.changeEditingModeOnF2(e))
  },
  destroyed () {
    document.removeEventListener('keydown', e => this.changeEditingModeOnF2(e))
  },
  methods: {
    changeEditingMode (value) {
      this.$store.commit('SET_TABLE_EDITING_MODE', value)
    },
    changeEditingModeOnF2 (e) {
      const { code } = e
      if (code !== 'F2') return
      this.changeEditingMode(!this.isTableEditingMode)
    }
  },
  props: {
    buttonColor: {
      type: String,
      default: 'mainButtons'
    }
  }
}
</script>
